<template>
  <a href="https://www.randboats.com/" target="_blank">
    <img src="https://firebasestorage.googleapis.com/v0/b/rand-boats.appspot.com/o/RAND%20Boats%20logo.svg?alt=media&token=d35a7ebb-7197-4be2-bb3a-b14fd20061e5" alt="logo" />
  </a>
</template>

<script>
export default {
  name: 'cLogo',
}
</script>
